import { useQuery } from '@tanstack/react-query'
import { DashboardApi } from '@/services/api-routes'
import { indicadoresDashboardVazio } from '@/types/dashboard'
import { dashboardKeys } from '@/http/queryKeys'
import { defaultOptions, liveOptions } from '@/http/default-query-options'

export const useIndicadoresDashboardQuery = () =>
  useQuery({
    queryKey: dashboardKeys.indicadores(),
    queryFn: async ({ signal }) =>
      (await DashboardApi.indicadores(signal)) ?? indicadoresDashboardVazio,
    ...liveOptions,
  })

export const useSaudeDashboardQuery = () =>
  useQuery({
    queryKey: dashboardKeys.saude(),
    queryFn: async ({ signal }) => (await DashboardApi.saude(signal)) ?? [],
    refetchInterval: 30_000,
    ...liveOptions,
  })

export const useAlertasDashboardQuery = () =>
  useQuery({
    queryKey: dashboardKeys.alertas(),
    queryFn: async ({ signal }) => (await DashboardApi.alertas(signal)) ?? [],
    ...liveOptions,
  })

export const usePreferenciaIndicadoresQuery = (perfil: string, enabled = true) =>
  useQuery({
    queryKey: dashboardKeys.preferenciaIndicadores(perfil),
    queryFn: async ({ signal }) =>
      (await DashboardApi.preferenciaIndicadores(perfil, signal)) ?? [],
    enabled,
    ...defaultOptions,
  })
